import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CGUID, SyncSeekUrl, SyncPullSerializedUrl,GetDatasyncMediaOneBlockSynchronously,SyncDeleteSynchronously} from "datasync-core";
import { globals} from "../Components/Globals/Globals";
import { produce } from 'immer';
const initialState = {
  awardsItems: [],
  awardCount: 0,
  loadAwards_result:{status: 'idle', error: null},
  deleteAward_result:{status: 'idle', error: null},
}

// Create an async thunk for loading awards
export const loadAwards = createAsyncThunk(
  'awards/loadAwards',
  async (thunkAPI) => {
    try {
      const response = await GetDatasyncMediaOneBlockSynchronously({
        session_guid: CGUID(),
        date_synchro: '1970-07-10 063050',
        company_guid: globals.datasync.platform_company_guid,
        datasync_url: globals.datasync_service.url,
        syncSeekUrl: SyncSeekUrl(globals.datasync_service.url),
        SyncPullSerializedGETurl: SyncPullSerializedUrl(globals.datasync_service.url),
        seek_filter_clause: ` true `, // Do not filter awards
        table_guid: globals.datasync.pf_awards_table_guid,
        debugging: true
      });
      if (globals.parameters.debugging)
        console.log("loadAwards::awards response = ",response)
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Create an async thunk for deleting awards
export const deleteAward = createAsyncThunk(
  'awards/deleteAward',
  async (deletedAwardObject) => {
    try {
      console.clear()
      console.log("deletedAwardObject->", deletedAwardObject)
      //Delete award from Remote Datasync Database
      const response = await SyncDeleteSynchronously({
        datasync_url:globals.datasync_service.url,
        data_guid: deletedAwardObject.data_guid});
      
      if (globals.parameters.debugging)
        console.log("deleteAward->response = ",response)

      if (response.err || response.deleted_data_count !=1)
        throw(response.err)

      return response;
    } catch (error) {
      return deletedAwardObject.rejectWithValue(error.message);
    }
  }
);

const awardSlice = createSlice({
  name: 'awards',
  initialState,
  reducers: {
    addAward(state, action) {
      // New stat added 
      try {
        if (globals.parameters.debugging){
          console.log("addAward: ", state.awardsItems)
          console.log("addAward: ", state.awardCount)
          console.log("addAward::action ->", action)  
        }
  
        state.awardCount++;
        state.awardsItems.push(action.payload);
      } catch (error) {
        console.error("Award added but state list insertion fails !")
        alert("Echec de l'insertion du nouvel utilisateur en mémoire interne")
      }
    },

    updateAward(state, action) {
      return produce(state, draft => {
        //Find former stat object to update
        const updatedAwardObject = draft.awardsItems.find((award) => award.data_guid === action.payload.data_guid)
        console.log("updateAward: updatedAwardObject->", updatedAwardObject)
        if (updatedAwardObject) {
          //update award in the array
          updatedAwardObject.data_blob.data_tier = action.payload.data_blob.data_tier;
        } else {
          console.error("updateAward: Award not found in the array");
        }
      })
    },

    revertAllAwards(state){
      console.log("awardSlice revertAllAwards");
      state.awardsItems = [];
      state.awardCount = 0;
      state.loadAwards_result = {status: 'idle', error: null};
      state.deleteAward_result = {status: 'idle', error: null};
    },

    revertStatusAwards(state){
      if (globals.parameters.debugging)
        console.log("revertStatusAwards")

      state.deleteAward_result = {status: 'idle', error: null};
    }
  },
  extraReducers: (builder) => {
    builder
      /* loadAwards */
      .addCase(loadAwards.pending, (state, action) => {
        state.loadAwards_result = {status : "loading",error : null};
      })
      .addCase(loadAwards.fulfilled, (state, action) => {
        if (action.payload.length > 0) {
          state.loadAwards_result = {status : "succeeded",error : null};
          state.awardsItems = action.payload;
          state.awardCount= action.payload.length;
        }
        else {
          state.loadAwards_result = {status : "succeeded",error : "No awards found !!!"};
          state.awardsItems = [];
          state.awardCount= 0;
        }
      })
      .addCase(loadAwards.rejected, (state, action) => {
        state.loadAwards_result = {status : "failed",error : action.payload};
      })

      /* deleteAward */
      .addCase(deleteAward.pending, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteAward.pending")
        console.log("deleteAward.pending -> action", action)
        state.deleteAward_result = {status : "deleting",error : null};
      })
      .addCase(deleteAward.fulfilled, (state,action) => {
        //Award sucessfully deleted from syncDeleteAsynchronous process
        if (globals.parameters.redux_debugging) alert("deleteAward.fulfilled")
          console.log("deleteAward.fulfilled -> action", action, " state->", state)

        return produce(state, draft => {
          //Delete award from local state
          draft.awardsItems = draft.awardsItems.filter((award, j) => award.data_guid !== action.payload.data_guid)
          draft.awardCount--;

          draft.deleteAward_result = {status : "deleted",error : null};
        })
      })
      .addCase(deleteAward.rejected, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteAward.rejected")
          console.log("deleteAward.rejected -> action", action)
        state.deleteAward_result = {status : "failed",error : action.payload};
      })
  },
});

export const { addAward, updateAward, revertAllAwards, revertStatusAwards } = awardSlice.actions;
export default awardSlice.reducer;